import { render, staticRenderFns } from "./SaveLinkModal.vue?vue&type=template&id=2c3f7977&scoped=true&"
import script from "./SaveLinkModal.vue?vue&type=script&lang=js&"
export * from "./SaveLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveLinkModal.vue?vue&type=style&index=0&id=2c3f7977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f7977",
  null
  
)

component.options.__file = "SaveLinkModal.vue"
export default component.exports